import { IBookingModel } from '@services/api/booking/booking-model.interface';
import { IParkingRequestModel } from '@services/api/parking-request/parking-request-model.interface';
import { Injectable } from '@angular/core';

/**
 * Interface for readonly state of form fields
 */
export interface ReadonlyState {
  booking: boolean;
  parkingPlace: boolean;
  startDate: boolean;
  endDate: boolean;
}

/**
 * Service to determine which form fields should be readonly based on edit mode and dates
 */
@Injectable({
  providedIn: 'root'
})
export class ParkingRequestReadonlyStateService {
  /**
   * Determine readonly state for form fields
   * @param editMode Whether we're in edit mode
   * @returns ReadonlyState object indicating which fields should be readonly
   */
  determineReadonlyState(editMode: boolean): ReadonlyState {
    // In create mode, all fields are editable
    if (!editMode) {
      return {
        booking: false,
        parkingPlace: false,
        startDate: false,
        endDate: false
      };
    }

    // In edit mode, only booking and parking place are readonly
    // Date fields remain editable (min/max constraints provide sufficient control)
    return {
      booking: true, // Always readonly in edit mode
      parkingPlace: true, // Always readonly in edit mode
      startDate: false, // Always editable (min/max constraints handle validation)
      endDate: false // Always editable (min/max constraints handle validation)
    };
  }

  /**
   * Check if a field should be readonly
   * @param fieldName Name of the field to check
   * @param readonlyState Current readonly state
   * @returns true if field should be readonly
   */
  isFieldReadonly(fieldName: keyof ReadonlyState, readonlyState: ReadonlyState): boolean {
    return readonlyState[fieldName];
  }
}
